import { jump, getDataThrowToMicroapp } from '@/pages/activity-manage/merchants/venue-detail/constants/index';
import queryString from 'query-string';
import type { DataType } from '@/pages/activity-manage/merchants/venue-detail/constants/index';

const baseLink = '/activity-manage/myCreate/daily-activities-manager';

const data = getDataThrowToMicroapp({ baseLink });
const handelParams = (query: string = '') => {
  const [pathname, realQuery] = query.split('?');
  const inputQuery = queryString.parse(realQuery);
  const curQuery = queryString.parse(window.location.search);

  return `${pathname}?${queryString.stringify({ ...curQuery, ...inputQuery })}`;
};
const _data: DataType = {
  ...data,
  // 资质设置
  sence: 'daily',
  jumpCollectionPoolSettings: (query, type) => {
    jump(baseLink + '/poolSetting' + handelParams(query), type);
  },
  // 管理者者提报收品池列表 & 效果数据
  jumpCollection: (query, type) => {
    jump(baseLink + '/materials/distribute/roomlist' + query, type);
  },
  // 参与者收品池列表 & 效果数据
  jumpPoolList: (query, type) => {
    jump(baseLink + '/materials/distribute/roomlist' + query, type);
  },
  // 参与者收品池列表 & 效果数据
  jumpEffectData: (query, type) => {
    return jump(baseLink + '/materials/distribute/effectData' + query, type);
  },
  jumpManage(query, type) {
    jump(baseLink + '/managemc' + query, type);
  },
  jumpActivityData(query, type) {
    // 我和上面的如果没有流程数据就可以删掉了
    jump(baseLink + '/materials/distribute/manage/activityData/detail' + query, type);
  },
};

export default _data;
